import React from "react";
import { useNavigate } from "react-router-dom";

interface GuidelineModalProps {
    open: boolean;
    onClose: () => void;
}

const GuidelineModal: React.FC<GuidelineModalProps> = ({ open, onClose }) => {
    const navigate = useNavigate();
    if (!open) return null;

    return (
        <div
            role="presentation"
            style={{
                position: "fixed",
                zIndex: 1300,
                inset: 0,
            }}
        >
            {/* Backdrop */}
            <div
                aria-hidden="true"
                onClick={onClose}
                style={{
                    zIndex: -1,
                    position: "fixed",
                    inset: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    WebkitTapHighlightColor: "transparent",
                }}
            />

            <div tabIndex={0} data-test="sentinelStart" />

            {/* Modal container */}
            <div
                className="styles_guildlinePopup_container__d_YJ_ MuiBox-root css-0"
                tabIndex={-1}
            >
                {/* Header */}
                <div className="MuiBox-root css-0">
                    <div className="styles_guildlinePopup_titleContainer__ToxE8 MuiBox-root css-0">
                        <h6 className="MuiTypography-root MuiTypography-h6">
                            Điều kiện đổi điểm
                        </h6>

                        <button
                            className="MuiButtonBase-root MuiIconButton-root"
                            type="button"
                            style={{ padding: 0 }}
                            onClick={onClose}
                        >
                            <span className="MuiIconButton-label">
                                <svg
                                    className="MuiSvgIcon-root"
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                    style={{ fill: "rgb(96, 96, 96)" }}
                                >
                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div className="styles_guildlineStep_container__b3rXY MuiBox-root css-0">
                    {/* Image */}
                    <div className="MuiBox-root css-1vhky2f">
                        <img
                            alt="logo voucher"
                            src="https://gcs.buymed.com/thuocsi-live/images/20255340372e7478c419b066b59f43c9?quality=100"
                            style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "contain",
                            }}
                        />
                    </div>

                    {/* Info */}
                    <div className="styles_contentPopupCondition_wrapper__nkg0V MuiBox-root css-0">
                        {/* Điểm đổi */}
                        <div className="MuiGrid-root MuiGrid-container">
                            <div className="MuiGrid-root styles_contentPopupCondition_title__VfIwL MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-4">
                                Điểm đổi
                            </div>
                            <div className="MuiGrid-root styles_contentPopupCondition_value__LFUMF MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-8">
                                250 điểm
                                <hr className="MuiDivider-root styles_popupCondition_divider__xARVP" />
                            </div>
                        </div>

                        {/* Chi tiết ưu đãi */}
                        <div className="MuiGrid-root MuiGrid-container">
                            <div className="MuiGrid-root styles_contentPopupCondition_title__VfIwL MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-4">
                                Chi tiết ưu đãi
                            </div>
                            <div className="MuiGrid-root styles_contentPopupCondition_value__LFUMF MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-8">
                                Tặng Voucher 50.000đ Cho đơn hàng từ 2.500.000đ
                                <hr className="MuiDivider-root styles_popupCondition_divider__xARVP" />
                            </div>
                        </div>

                        {/* Điều kiện */}
                        <div className="MuiGrid-root MuiGrid-container">
                            <div className="MuiGrid-root styles_contentPopupCondition_title__VfIwL MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-4">
                                Điều kiện áp dụng
                            </div>
                            <div className="MuiGrid-root styles_contentPopupCondition_value__LFUMF MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-8">
                                <div>
                                    <h4>Khuyến mãi 50.000 theo hình thức đổi điểm tích luỹ</h4>
                                    <ul>
                                        <li>Áp dụng cho đơn hàng có từ 6 loại sản phẩm</li>
                                        <li>Mỗi voucher chỉ sử dụng 1 lần (có thể đổi nhiều voucher)</li>
                                        <li>Voucher có hiệu lực trong vòng 30 ngày kể từ ngày đổi điểm</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer button */}
                <div
                    className="MuiBox-root css-0"
                    style={{ textAlign: "center", marginTop: 12 }}
                >
                    <button
                        className="MuiButtonBase-root MuiButton-root MuiButton-text styles_popupCondition_buyMore___t4FR"
                        type="button"
                        onClick={() => navigate("/quick-order")}
                    >
                        <span className="MuiButton-label">
                            <span>Tích thêm điểm</span>
                        </span>
                    </button>
                </div>
            </div>

            <div tabIndex={0} data-test="sentinelEnd" />
        </div>
    );
};

export default GuidelineModal;
